/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgCarcierge48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      fill='none'
      viewBox='0 0 48 48'
      {...props}
    >
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M11.586 21.672V9.244A7.745 7.745 0 0119.331 1.5H24'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M11.586 12.362H9.21a2.28 2.28 0 00-2.279 2.279v6.304a2.279 2.279 0 002.279 2.279h2.376V12.362z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M24.006 42.916c-6.213 0-10.092-4.95-10.092-4.95M17.08 32.152l-.546 3.279a2.795 2.795 0 01-2.011 2.235L3.82 40.628c-.381.105-.742.267-1.073.482L.53 42.548M34.32 4.224s-1.855 6.994-16.556 6.25'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M36.414 21.672V9.244A7.745 7.745 0 0028.669 1.5H24'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M36.414 12.362h2.376a2.28 2.28 0 012.279 2.279v6.304a2.279 2.279 0 01-2.279 2.279h-2.376V12.362z'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M23.994 42.916c6.213 0 10.092-4.95 10.092-4.95M30.92 32.152l.546 3.279a2.795 2.795 0 002.011 2.235l10.703 2.962c.38.105.742.267 1.072.482l2.217 1.438M11.586 22.448v3.568a7.04 7.04 0 006.5 7.019l3.587.276'
      />
      <path
        stroke='currentColor'
        strokeLinecap='square'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M30.733 30.983l.602 3.698'
      />
      <path
        stroke='currentColor'
        strokeMiterlimit={5}
        strokeWidth={1.5}
        d='M36.414 22.448a9.348 9.348 0 01-2.994 6.857c-1.638 1.343-2.529 1.419-3.453 1.832M23.903 35.344c1.232 0 2.23-1.029 2.23-2.297 0-1.27-.998-2.298-2.23-2.298s-2.23 1.029-2.23 2.298c0 1.268.998 2.297 2.23 2.297zM23.861 15.764l1.912 5.909h-3.258'
      />
    </svg>
  );
}

export default SvgCarcierge48;
